
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SupabaseProvider } from "@/hooks/useSupabaseClient";
import Index from "./pages/Index";
import Anvandingsfall from "./pages/Anvandingsfall";
import Priser from "./pages/Priser";
import NotFound from "./pages/NotFound";
import Integritetspolicy from "./pages/Integritetspolicy";
import Villkor from "./pages/Villkor";
import Cookies from "./pages/Cookies";
import GDPR from "./pages/GDPR";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Procurements from "./pages/Procurements";
import Analyses from "./pages/Analyses";
import NewProcurement from "./pages/NewProcurement";
import Profile from "./pages/Profile";
import { useScrollToTop } from "./hooks/use-scroll-to-top";

const queryClient = new QueryClient();

// ScrollToTop component that uses the hook
const ScrollToTop = () => {
  useScrollToTop();
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <SupabaseProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Index />} />
            <Route path="/anvandingsfall" element={<Anvandingsfall />} />
            <Route path="/priser" element={<Priser />} />
            <Route path="/integritetspolicy" element={<Integritetspolicy />} />
            <Route path="/villkor" element={<Villkor />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/gdpr" element={<GDPR />} />
            <Route path="/auth" element={<Auth />} />
            
            {/* Protected routes - in a real app, these would have proper auth guards */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/procurements" element={<Procurements />} />
            <Route path="/analyses" element={<Analyses />} />
            <Route path="/new-procurement" element={<NewProcurement />} />
            <Route path="/profile" element={<Profile />} />
            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </SupabaseProvider>
  </QueryClientProvider>
);

export default App;
